import { useQueries } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { getMonitoringFormResultsForList } from 'src/services/api/api-client/ConfigurableMonitoringFormsClient';
import { getMonitoringFormResultsForListQueryKey } from 'src/services/api/api-client/ConfigurableMonitoringFormsQuery';
import _ from 'lodash';

export const useGetMonitoringResultsForStudy = () => {
  const { monitoringFormConfigs } = useStudy() ?? {};

  const monitoringFormsResultsQuery = useQueries({
    queries: (monitoringFormConfigs ?? []).map((config) => ({
      queryKey: getMonitoringFormResultsForListQueryKey(config.configId),
      queryFn: () => getMonitoringFormResultsForList(config.configId),
    })),
  });

  const isLoading = monitoringFormsResultsQuery.some((q) => q.isInitialLoading);

  const monitoringFormsResults = useMemo(
    () =>
      _.orderBy(
        monitoringFormsResultsQuery.flatMap((q) => q.data?.map((r) => r) ?? []) ?? [],
        (x) => x.updatedAt,
        'desc',
      ),
    [monitoringFormsResultsQuery],
  );

  const refetch = useCallback(
    () => monitoringFormsResultsQuery.forEach((q) => q.refetch()),
    [monitoringFormsResultsQuery],
  );

  return { isLoading, monitoringFormsResults, refetch };
};
